import React, { FC } from 'react'

const ExpandIcon: FC = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26">
			<rect width="24" height="24" x="1" y="1" className="stroke-brand-primary-md" strokeWidth="2" rx="12"></rect>
			<path
				className="fill-brand-primary-md stroke-brand-primary-md"
				d="M7.043 10.943a.652.652 0 011.114-.462l4.52 4.52 4.519-4.52a.652.652 0 11.922.924l-4.98 4.98a.652.652 0 01-.923 0l-4.98-4.98a.649.649 0 01-.192-.462z"
			></path>
		</svg>
	)
}

export default ExpandIcon
